export default __webpack_public_path__ + "static/media/LaGalera2.c24546a1.jpeg";